import React from "react";
import { formatDate, dateObjToShortStr } from "../../utilities/helpers";
import { add_shift_attributes } from "../../utilities/helpers";
import { formatDateShift } from "../../utilities/helpers";
import CircularProgress from "@mui/material/CircularProgress";
import EmployeeShiftCardToday from "./EmployeeShiftCardToday";
import EmployeeTasksSection from "./EmployeeTasksSection";
import EmployeeShiftCardUpdated from "../../shared/shiftswaps/EmployeeShiftCardUpdated";
import NoShiftBar from "../../shared/helpers/NoShiftBar";

export default function HomeDisplayEmployee(props) {

  const today = new Date();

  let myShiftsToday = props.myUpcomingShifts.filter(
    (v, i) => v.date === formatDate(today)
  );

  myShiftsToday = myShiftsToday?.map((v, i) => add_shift_attributes(v));
  // What is still to do, not everything the day holds: the payload carries
  // finished work and occurrences that have not opened yet.
  const openTaskCount = (props.tasks || []).filter((t) => !t.submitted_at).length;

  let myShiftsUpcoming = props.myUpcomingShifts?.filter(
    (v, i) => v.date > formatDate(today)
  );

  myShiftsUpcoming = myShiftsUpcoming?.sort((a, b) => a.date - b.date);

  myShiftsUpcoming = myShiftsUpcoming?.map((v, i) => add_shift_attributes(v));


  const filterScheduleData = (scheduleData, selectedDate, myShift) => {
    let dayScheduleData = [];
    if (scheduleData) {
      dayScheduleData = scheduleData.filter((v, i) => v.date === selectedDate);
    }
    dayScheduleData = dayScheduleData.map((v, i) => add_shift_attributes(v));

    // Get the store ID from your shift
    const storeId = myShift?.store?.id;

    let alsoWorking = dayScheduleData.filter(
      (v, i) => v.store_team_member?.user?.id !== props.myUserId
    );

    // Filter to only include coworkers at the same store
    if (storeId) {
      alsoWorking = alsoWorking.filter((v) => v.store?.id === storeId);
    }

    // Further filter to only include coworkers with overlapping shifts
    alsoWorking = alsoWorking?.filter(
      (v, i) =>
        (v.shift_start < myShift.shift_end &&
          v.shift_end > myShift.shift_start) ||
        (v.shift_start < myShift.shift_start &&
          v.shift_end > myShift.shift_start) ||
        (v.shift_start < myShift.shift_end &&
          v.shift_end > myShift.shift_end)
    );

    return alsoWorking;
  };

  // Function to get alsoWorking data for a specific shift
  const getAlsoWorkingForShift = (shift) => {
    return filterScheduleData(props.scheduleData, shift.date, shift);
  };

  function getGreeting() {
    const now = new Date();
    const currentHour = now.getHours();

    if (currentHour >= 5 && currentHour < 12) {
      return "Good Morning";
    } else if (currentHour >= 12 && currentHour < 17) {
      return "Good Afternoon";
    } else {
      return "Good Evening";
    }
  }

  let notMyUpcomingShifts = props.notMyUpcomingShifts.map((v, i) =>
    add_shift_attributes(v)
  );


  return (
    <>
      {props.scheduleData ? (
        <div className="w-full bg-white">
          <div className="mt-12 px-6">
            <p className="text-slate-500 text-sm">{dateObjToShortStr(today)}</p>
            <h2 className="text-slate-900 text-3xl font-bold mt-2">
              {getGreeting()}, {props.firstName}
            </h2>
          </div>
          <div className="mt-8 px-6">
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Today</p>
            {myShiftsToday?.length > 0 ? (
              <div className="flex items-start gap-x-4">
                {myShiftsToday?.map((shift, index) => (
                  <div key={index} className="mt-3 w-96">
                    <EmployeeShiftCardToday
                      key={index}
                      shift={shift}
                      firstName={shift.store_team_member?.first_name}
                      lastName={shift.store_team_member?.last_name}
                      date={shift.date}
                      shiftStartNumber={shift.shift_start_formatted[0]}
                      shiftStartLetters={shift.shift_start_formatted[1]}
                      shiftEndNumber={shift.shift_end_formatted[0]}
                      shiftEndLetters={shift.shift_end_formatted[1]}
                      role={shift.role}
                      roleType={shift.role_type}
                      roleId={shift.role_id}
                      station={shift.station?.name}
                      location={shift.location}
                      break={shift.break_formatted}
                      alsoWorking={getAlsoWorkingForShift(shift)}
                      roleNames={props.roleNames}
                      note={shift.note}
                      dailyEvents={shift.daily_events}
                      publishedScheduleId={shift.id}
                      notMyUpcomingShifts={notMyUpcomingShifts}
                      drop_shift={props.drop_shift}
                      trade_shift={props.trade_shift}
                      rescind_drop_shift={props.rescind_drop_shift}
                      rescind_trade_shift={props.rescind_trade_shift}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="mt-3 w-96">
                <NoShiftBar text="No shift today, enjoy your day off!" />
              </div>
            )}
          </div>
          {/* Eligibility comes from the roster, not from the schedule, so the
              day's tasks are here whether or not the person is on shift. */}
          {props.tasks?.length > 0 && (
            <div className="mt-3 px-6 w-96">
              <EmployeeTasksSection
                tasks={props.tasks}
                save_plan_task_assignment={props.save_plan_task_assignment}
                refreshOccurrences={props.refreshOccurrences}
                homeCompany={props.homeCompany}
                roleNames={props.roleNames}
              />
            </div>
          )}
          {openTaskCount > 0 && props.onOpenTasks && (
            <div className="mt-3 px-6">
              <button
                onClick={props.onOpenTasks}
                className="text-sm text-slate-500 hover:text-violet-700"
              >
                {openTaskCount} task{openTaskCount === 1 ? "" : "s"} left today ·{" "}
                <span className="font-semibold text-violet-700">Open Tasks</span>
              </button>
            </div>
          )}
          <div className="w-full mt-8 px-6">
            <div className="w-full flex items-center justify-between">
              <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">
                {myShiftsUpcoming.length > 0
                  ? "Upcoming"
                  : "No Shifts Upcoming"}
              </p>
              {props.setCurrentTab && (
                <button
                  className="text-violet-600 text-xs hover:text-violet-700"
                  onClick={() => props.setCurrentTab("Schedule")}
                >
                  {myShiftsUpcoming.length > 0 ? "View All" : "Calendar"}
                </button>
              )}
            </div>
            <div className="flex gap-x-4 flex-wrap pb-10">
              {myShiftsUpcoming.map((shift, index) => (
                <div key={index} className="mt-3 w-96">
                  <EmployeeShiftCardUpdated
                    key={index}
                    firstName={shift.store_team_member?.first_name}
                    lastName={shift.store_team_member?.last_name}
                    date={shift.date}
                    dateFormatted={formatDateShift(shift.date)}
                    shiftStartNumber={shift.shift_start_formatted[0]}
                    shiftStartLetters={shift.shift_start_formatted[1]}
                    shiftEndNumber={shift.shift_end_formatted[0]}
                    shiftEndLetters={shift.shift_end_formatted[1]}
                    role={shift.role}
                    station={shift.station?.name}
                    roleType={shift.roleType}
                    location={shift.location}
                    break={shift.break_formatted}
                    shift={shift}
                    notMyUpcomingShifts={notMyUpcomingShifts}
                    drop_shift={props.drop_shift}
                    trade_shift={props.trade_shift}
                    rescind_drop_shift={props.rescind_drop_shift}
                    rescind_trade_shift={props.rescind_trade_shift}
                    roleId={shift.role_id}
                    roleNames={props.roleNames}
                    note={shift.note}
                    dailyEvents={shift.daily_events}
                    alsoWorking={getAlsoWorkingForShift(shift)}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full h-screen flex items-center justify-center">
          <CircularProgress sx={{ color: "#6d28d9" }} />
        </div>
      )}
    </>
  );
}
